import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/weekly')({
  component: AnalyticsMoveWeeklyLayout,
});

function AnalyticsMoveWeeklyLayout() {
  return <Outlet />;
}
